import { AxiosRequestConfig } from 'axios';
import { HttpResponse, ajax } from '../../../../common/ajax';

import { config } from '../../config';
import { EmployeeBenefitInfoModel } from '../../models/EmployeeBenefitInfoModel';
import { EmployeeBenefitItemModel } from '../../models/EmployeeBenefitItemModel';

interface IEmployeeBenefitsService {
  getEmployeesBenefits: (
    queryString?: string,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<EmployeeBenefitItemModel[]>>;
  getBenefitInfo: (
    orderId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<EmployeeBenefitInfoModel>>;
  cancelSubscription: (
    orderProductId: number,
    axiosConfig?: AxiosRequestConfig,
  ) => Promise<HttpResponse<any>>;
}

export const employeeBenefitsService: IEmployeeBenefitsService = {
  getEmployeesBenefits(
    queryString,
    axiosConfig,
  ): Promise<HttpResponse<EmployeeBenefitItemModel[]>> {
    return ajax.get<EmployeeBenefitItemModel[]>(
      `${config.benefitApiUrl}/odata/employees-benefits?${queryString}`,
      axiosConfig,
    );
  },
  getBenefitInfo(
    orderId,
    axiosConfig,
  ): Promise<HttpResponse<EmployeeBenefitInfoModel>> {
    return ajax.get<EmployeeBenefitInfoModel>(
      `${config.benefitApiUrl}/employees-benefits/${orderId}`,
      axiosConfig,
    );
  },
  cancelSubscription(orderProductId, axiosConfig) {
    return ajax.post(
      `${config.benefitApiUrl}/employees-benefits/cancel-subscription`,
      { orderProductId },
      axiosConfig,
    );
  },
};
